"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackdriverErrorReporting = void 0;
const stackdriver_errors_js_1 = __importDefault(require("stackdriver-errors-js"));
function setup({ serviceId, serviceVersion, apiKey, projectId, consoleOnly = false, }) {
    const isBrowser = typeof document !== "undefined";
    if (isBrowser && !consoleOnly) {
        const errorHandler = new stackdriver_errors_js_1.default();
        errorHandler.start({
            key: apiKey,
            projectId,
            service: serviceId,
            version: serviceVersion,
            // The following optional arguments can also be provided:
            // service: myServiceName,
            // Name of the service reporting the error, defaults to 'web'.
            // version: myServiceVersion,
            // Version identifier of the service reporting the error.
            // reportUncaughtExceptions: false
            // Set to false to prevent reporting unhandled exceptions, default: `true`.
            // reportUnhandledPromiseRejections: false
            // Set to false to prevent reporting unhandled promise rejections, default: `true`.
            // disabled: true
            // Set to true to not send error reports, this can be used when developing locally, default: `false`.
            // context: {user: 'user1'}
            // You can set the user later using setUser()
        });
        return errorHandler;
    }
    return {
        report: (error) => {
            console.error(error);
            console.warn(!isBrowser
                ? `Can't use JS StackdriverErrorHandler from Server Side`
                : "(Error reporting set to console only mode)");
        },
        setUser: () => {
            console.warn(!isBrowser
                ? `Can't use JS StackdriverErrorHandler from Server Side`
                : "(Error reporting set to console only mode - no user set)");
        },
    };
}
exports.StackdriverErrorReporting = {
    setup,
};
